import React, { useState } from 'react';
import { Clock, History } from 'lucide-react';
import { EditHistoryDialog } from './EditHistoryDialog';

export function LastEditedBy({ name, timestamp, className = '', resourceType, resourceId, pageName }) {
  const [showHistory, setShowHistory] = useState(false);
  if (!name && !timestamp) return null;

  const formatTime = (ts) => {
    if (!ts) return '';
    const date = new Date(ts);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'baru sahaja';
    if (diffMins < 60) return `${diffMins} minit lalu`;
    if (diffHours < 24) return `${diffHours} jam lalu`;
    if (diffDays < 7) return `${diffDays} hari lalu`;
    return date.toLocaleDateString('ms-MY', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  const hasHistoryLink = resourceType && resourceId;

  return (
    <>
      <div 
        className={`flex items-center gap-1.5 text-[11px] text-[hsl(var(--text-muted))] ${hasHistoryLink ? 'cursor-pointer hover:text-[hsl(var(--text-secondary))] transition-colors' : ''} ${className}`} 
        data-testid="last-edited-by"
        onClick={() => hasHistoryLink && setShowHistory(true)}
        title={hasHistoryLink ? 'Klik untuk lihat sejarah edit' : undefined}
      >
        <Clock size={12} className="text-[hsl(var(--text-muted))] opacity-60" />
        <span>
          {name && <span>Diedit oleh <span className="font-medium text-[hsl(var(--text-secondary))]">{name}</span></span>}
          {timestamp && <span> · {formatTime(timestamp)}</span>}
        </span>
        {hasHistoryLink && <History size={10} className="ml-1 opacity-40" />}
      </div>

      {hasHistoryLink && (
        <EditHistoryDialog
          open={showHistory}
          onOpenChange={setShowHistory}
          resourceType={resourceType}
          resourceId={resourceId}
          pageName={pageName}
        />
      )}
    </>
  );
}
